export type QuestionnaireType = "display" | "group" | "gtable" | "string" | "text" | "integer" | "quantity" | "decimal" | "choice" | "date" | "dateTime";

export interface IQuestionnaire {
  _guid: string;
  _childGuids: string[];
  type?: QuestionnaireType;
  linkId: string;
  text: string;
  repeats?: boolean;
  maxOccurs?: number;
  fhirPath?: IQuestionnaireExtension;
  display?: string;
  code?: string;
  gtable?: IQuestionnaireExtension;
  answerOption?: IQuestionnaireOption[];
}

export function instanceOfIQuestionnaire(instance: any): instance is IQuestionnaire {
  return instance && (instance.linkId !== undefined);
}

export interface IQuestionnaireExtension {
  url: string;
  valueExpression?: IQuestionnaireExpression;
  valueCodeableConcept?: IQuestionnaireCodeableConcept;
}

export function instanceOfIQuestionnaireExtension(instance: any): instance is IQuestionnaireExtension {
  return instance && (instance.url !== undefined);
}

export interface IQuestionnaireExpression {
  expression: string;
  name?: string;
  language?: string;
}

export function instanceOfIQuestionnaireExpression(instance: any): instance is IQuestionnaireExpression {
  return instance && (instance.expression !== undefined);
}

export interface IQuestionnaireCodeableConcept {
  coding: IQuestionnaireCoding[];
  text?: string;
}

export function instanceOfIQuestionnaireCodeableConcept(instance: any): instance is IQuestionnaireCodeableConcept {
  return instance && (instance.coding !== undefined);
}

export interface IQuestionnaireOption {
  valueCoding: IQuestionnaireCoding;
}

export function instanceOfIQuestionnaireOption(instance: any): instance is IQuestionnaireOption {
  return instance && (instance.valueCoding !== undefined);
}

export interface IQuestionnaireCoding {
  code: string;
  system?: string;
  display?: string;
}

export function instanceOfIQuestionnaireCoding(instance: any): instance is IQuestionnaireCoding {
  return instance && (instance.code !== undefined);
}
